import React from "react";
import { Card, Button, Typography, Space, Grid } from "antd";
import { CheckOutlined, ArrowRightOutlined, HomeOutlined, CheckCircleOutlined, FileTextOutlined } from "@ant-design/icons";
import SidebarLayoutConsumer from "../Administrator/SidebarLayoutConsumer";
import { routes } from "../../../routes/Routes";
import { useHistory } from "react-router-dom";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const ApplicationSubmitted = () => {
  const screens = useBreakpoint();
  const history = useHistory();

  const ViewMyApplications = () => {
    history.push({ pathname: routes.consumerDashboard.path });
  }

  const BacktoDashboard = () => {
    history.push({ pathname: routes.consumerDetailsDashboard.path });
  }


  return (
    <SidebarLayoutConsumer>
      {/* Parent: Layout Wrapper */}
      <div className="submission-layout">

        {/* Child: Main Container */}
        <div className="submission-container">

          {/* Section: Status Header */}
          <div className="status-header">
            <div className="status-icon-wrapper">
              <CheckCircleOutlined className="status-icon" />
            </div>

            <Title level={2} className="status-title">
              Application Submitted Successfully!
            </Title>

            <Text className="status-description">
              Your liquidity application has been received and is now under review.
              <br className="desktop-break" />
              We’ll notify you once the review process is complete.
            </Text>
          </div>

          {/* Section: Next Steps Card */}
          <Card className="next-steps-card" bordered={false}>
            <Title level={5} className="card-heading">What happens next?</Title>

            <div className="process-list">
              <div className="process-item">
                <span className="process-index">1</span>
                <Text className="process-text">
                  Our team will review your application and supporting documents
                </Text>
              </div>

              <div className="process-item">
                <span className="process-index">2</span>
                <Text className="process-text">
                  We’ll calculate your credit metrics and assess your eligibility
                </Text>
              </div>

              <div className="process-item">
                <span className="process-index">3</span>
                <Text className="process-text">
                  You’ll receive a notification with outcome within 5–7 business days
                </Text>
              </div>
            </div>
          </Card>

          {/* Section: Action Buttons */}
          <div className="action-buttons">
            <Button
              type="primary"
              className="btn-primary-action"
              onClick={BacktoDashboard}
            >
              <FileTextOutlined /> View My Applications <ArrowRightOutlined/>
            </Button>

            <Button
              type="default"
              className="btn-secondary-action"
              onClick={ViewMyApplications}
            >
              <HomeOutlined /> Back to Dashboard
            </Button>
          </div>

          {/* Section: Support Footer */}
          {/* <div className="support-footer">
            <Text className="support-text">
              Need help? Contact our support team at{' '}
              <a href="mailto:support@platform.com" className="support-link">support@platform.com</a>
            </Text>
          </div> */}

          <div className="support-footer">
            <Text className="support-text">
              <span className="help-highlight">Need help?</span> Contact our support team at{' '}
              <a href="mailto:support@platform.com" className="support-link">support@levridge.ai</a>
            </Text>
          </div>

        </div>
      </div>
    </SidebarLayoutConsumer>
  );
};

export default ApplicationSubmitted;